export default {
  white: "#fff",
  black: "#000",
  lime: "#bfdd25",
  red: "#ff5733",
  blue: "#099fdb",
  lightBlue: "#69cfe4",
  orange: "#fbb436",
  yellow: "#ffe905",
  green: "#4dbd00",
  darkGreen: "#27372f",
  darkGrey: "#3e3e3d",
  grey: "#758289",
  neutralLightColor: "#d0c9d6",
  neutralColor: "#e9e6ef",
  neutralLighterColor: "#ecebed",
  getRGBA: function(color, opacity) {
    const r = parseInt(color.substr(1, 2), 16);
    const g = parseInt(color.substr(3, 2), 16);
    const b = parseInt(color.substr(5, 2), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity}`;
  }
};
